import { useFormik } from 'formik';
import * as yup from 'yup';
import { TextField } from '@habitech/keychain-atoms-inputs';
import { Button, DropdownButton } from '@habitech/call-to-action';
import Loading from 'src/components/common/Loading/Loading';
import { WrapperButton } from '../styles';
import { ButtonSelection } from 'src/components/common/ButtonSelection/ButtonSelection';
import { SearchInputResult } from 'src/components/common/SearchInputResults';
import { Label } from './styles';
import { Checkbox } from '@habitech/selectors';
import { fromDataList, typeOfUser } from './constants';

type PropsForm = {
    handleSearch?: Function;
    loadingList?: boolean;
    resetValues?: Function;
};

export type initialValuesProps = {
    from_xml: string;
    direction_id: number | string;
    type_user: string | any;
    from_data: string;
    lead_min: number;
    lead_max: number;
};

const initialValues: initialValuesProps = {
    from_xml: '0',
    direction_id: '',
    type_user: [],
    from_data: 'sin',
    lead_min: 0,
    lead_max: 0,
};

const LocationForm = ({ loadingList, handleSearch, resetValues }: PropsForm) => {
    const validationSchema = yup.object({
        direction_id: yup.string().required('Escriba una ubicación'),
        type_user: yup.array().of(yup.string().trim().required('Debe escoger un tipo de usuario')).min(1, 'Debe escoger un tipo de usuario'),
        from_data: yup.string().required('Seleccione un origen'),
    });

    const formik = useFormik({
        initialValues,
        validationSchema: validationSchema,
        onSubmit: (values: any) => {
            const val = { ...values, from_data: values.from_data === 'sin' ? '0' : values.from_data, type_user: values.type_user.join() };
            handleSearch(val);
            resetValues();
        },
    });

    const handleResetForm = () => {
        formik.resetForm();
        resetValues();
    };

    const handleCheckboxChange = (val: string | number) => {
        const isChecked = formik.values.type_user.includes(val);
        if (isChecked) {
            const items = formik.values.type_user.filter((item) => item !== val);
            formik.setFieldValue('type_user', items, false);
        } else {
            formik.setFieldValue('type_user', [...formik.values.type_user, val], false);
        }
    };
    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <ButtonSelection
                    listOptions={[
                        { label: 'Manual', value: '0', enabled: true },
                        { label: 'Feed', value: '1', enabled: true },
                    ]}
                    onChange={(e) => formik.setFieldValue('from_xml', e.value, false)}
                    label="Selecciona el tipo de anunciante"
                    defaultValue={formik.values.from_xml}
                />
                <Label>Selecciona ubicación</Label>
                <SearchInputResult
                    error={JSON.stringify(formik.errors.direction_id)}
                    initialValue={formik.values.direction_id}
                    onChange={(val) => formik.setFieldValue('direction_id', val.id, false)}
                />
                <Label>Selecciona el tipo de usuario</Label>
                <WrapperButton className="checkboxs">
                    {typeOfUser.map((item) => (
                        <Checkbox
                            key={item}
                            dataId="test-type_user"
                            id="test-id"
                            name="type_user"
                            originType="pcom"
                            type="rounded"
                            value={item}
                            labelText={item}
                            selected={formik.values.type_user.includes(item)}
                            onChange={(val) => handleCheckboxChange(val)}
                        />
                    ))}
                    {formik.errors.type_user ? <p className="error-text">* {JSON.stringify(formik.errors.type_user)}</p> : ''}
                </WrapperButton>

                <Label>Origen de publicación</Label>
                <DropdownButton
                    dataId="test_from_data"
                    listOptions={fromDataList}
                    placeholder="Selecciona un origen"
                    setValue={(val) => formik.setFieldValue('from_data', val, false)}
                    variant="white"
                    originType="pcom"
                    size="large fluid"
                    defaultSelected={formik.values.from_data}
                />
                {formik.errors.from_data ? <p className="error-text">* {JSON.stringify(formik.errors.from_data)}</p> : ''}

                <Label>Leads recibidos</Label>
                <WrapperButton className="leads">
                    <TextField
                        dataId="lead_min"
                        name="lead_min"
                        label="Minimo"
                        originType="pcom"
                        placeHolder=""
                        innerLabel
                        type="number"
                        value={formik.values.lead_min || '0'}
                        onChange={(_, _vale, e) => formik.handleChange(e)}
                        error={Boolean(formik.errors.lead_min)}
                        errorMessage={JSON.stringify(formik.errors.lead_min)}
                    />

                    <TextField
                        dataId="lead_max"
                        name="lead_max"
                        label="Máximo"
                        originType="pcom"
                        placeHolder=""
                        innerLabel
                        type="number"
                        value={formik.values.lead_max || '0'}
                        onChange={(_, _vale, e) => formik.handleChange(e)}
                        error={Boolean(formik.errors.lead_max)}
                        errorMessage={JSON.stringify(formik.errors.lead_max)}
                    />
                </WrapperButton>

                <WrapperButton>
                    {!loadingList ? (
                        <>
                            <Button dataId="button-search" originType="pcom" size="large" type="submit">
                                Buscar
                            </Button>
                            <Button dataId="button-search" originType="pcom" variant="stroke" size="large" type="button" onClick={handleResetForm}>
                                Reestablecer valores
                            </Button>
                        </>
                    ) : (
                        <Loading className="loader-button" />
                    )}
                </WrapperButton>
            </form>
        </>
    );
};

export default LocationForm;
